import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  fatalErrorTitle: {
    id: 'general.fatalErrorTitle',
    defaultMessage: 'The application has encountered an error',
    description: 'Title of application error page',
  },
  fatalErrorDescription: {
    id: 'general.fatalErrorDescription',
    defaultMessage: 'An error occurred while sending the request. Please try again later.',
    description: 'Description of application error page',
  },
  fatalErrorCode: {
    id: 'general.fatalErrorCode',
    defaultMessage: 'Error code {errorCode}',
    description: 'Text for label of error code',
  },
  fatalErrorLinkHomePage: {
    id: 'general.fatalErrorLinkHomePage',
    defaultMessage: 'Home page',
    description: 'The name of link for home page',
  },
  fatalErrorLinkPreviousPage: {
    id: 'general.fatalErrorLinkPreviousPage',
    defaultMessage: 'Return to previous page',
    description: 'The name of link for return to previous page',
  },
});
